import styled from 'styled-components';

import { device } from 'config/device';

export const ListPageWrapper = styled.div`
  background: #fff;
  padding: 16px 32px;
  border-radius: 12px;
  margin-top: 20px;

  @media ${device.mobile} {
    padding: 8px 12px;
  }

  /* Short landscape (phones rotated): this wrapper is the single scroll area
     for both axes, so the "Choose item" header can scroll away, the list gets
     full height, the sticky column headers pin to the top, and wide tables
     scroll horizontally. Top padding stays 0 to avoid a gap above the header. */
  @media (max-height: 550px) and (orientation: landscape) {
    overflow: auto !important;
    padding-top: 0;
  }

  .disclaimerTitle {
    padding-bottom: 10px;

    @media ${device.mobile} {
      display: none;
    }
  }
  .disclaimerDesc {
    font-size: 14px;
    color: ${(props) => props.theme.gray3};
    padding-bottom: 10px;

    @media ${device.mobile} {
      display: none;
    }
  }
`;
